/** Parse one crew-entered garbage bag count (clear or black). */
export function parseBagCount(
  value: string,
  label: string
): { ok: true; value: number } | { ok: false; message: string } {
  const trimmed = value.trim()
  const parsed = Number(trimmed)
  if (trimmed === '' || !Number.isInteger(parsed) || parsed < 0) {
    return {
      ok: false,
      message: `Enter ${label} (0 or more).`,
    }
  }
  return { ok: true, value: parsed }
}

export function parseClearAndBlackBags(
  clear: string,
  black: string
):
  | { ok: true; clear: number; black: number }
  | { ok: false; message: string } {
  const blackResult = parseBagCount(black, 'black bags')
  if (!blackResult.ok) return blackResult
  const clearResult = parseBagCount(clear, 'clear bags')
  if (!clearResult.ok) return clearResult
  return { ok: true, clear: clearResult.value, black: blackResult.value }
}

export const BAGS_PER_BOX = 100

export const APP_SETTING_CLEAR_BOX_100 = 'garbage_bag_clear_box_100_cost'
export const APP_SETTING_BLACK_BOX_100 = 'garbage_bag_black_box_100_cost'

export function unitCostFromBoxOf100(boxOf100Cost: number): number {
  const box = Number(boxOf100Cost)
  if (!Number.isFinite(box) || box < 0) return 0
  return Math.round((box / BAGS_PER_BOX) * 10000) / 10000
}

/** Job bag COGS from counts and box-of-100 prices. */
export function computeGarbageBagsCost(
  clearBags: number,
  blackBags: number,
  clearBoxOf100Cost: number,
  blackBoxOf100Cost: number
): number {
  const clear = Math.max(0, Number(clearBags) || 0)
  const black = Math.max(0, Number(blackBags) || 0)
  const total =
    clear * unitCostFromBoxOf100(clearBoxOf100Cost) +
    black * unitCostFromBoxOf100(blackBoxOf100Cost)
  return Math.round(total * 100) / 100
}

export function parseBoxCostSetting(value: unknown): number {
  let raw = value
  if (typeof raw === 'string') {
    try {
      raw = JSON.parse(raw)
    } catch {
      // plain numeric string
    }
  }
  const n = Number(raw)
  return Number.isFinite(n) && n >= 0 ? n : 0
}
